import { Application } from '~/types/Application';

export const getDisablePayment = (application?: Application): boolean => {
  return application?.disablePaymentStep ?? false;
};
